import relativeTime from 'dayjs/plugin/relativeTime'
import dayjs from 'dayjs'

dayjs.extend(relativeTime)

/**
 * Returns "Last updated X ago" relative to `now`.
 *
 * @param {string[]} dates       - Array of ISO date strings
 * @param {string|dayjs} [now]   - ISO string or dayjs to use as "current"
 * @returns {string}
 */
export function getLastUpdated(dates, now = dayjs()) {
  if (!Array.isArray(dates) || dates.length === 0) {
    return ''
  }

  const reference = dayjs(now)
  const nearest = dates.reduce((closest, current) => {
    const dClosest = Math.abs(dayjs(closest).diff(reference))
    const dCurrent = Math.abs(dayjs(current).diff(reference))
    return dCurrent < dClosest ? current : closest
  })

  return `Last updated ${dayjs(nearest).from(reference)}`
}
